<template>
	<div class="c-controls">
		<div class="c-controls__group">
			<label class="c-controls__label">Slot machine</label>
			<button class="button button--control" v-on:click.prevent="spin">Creëer een vraag</button>
		</div>
	</div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'HMWControl',
	mixins: [BaseControl],
	methods: {
		spin() {
			this.subcommand('hmw.spin');
		},
		startTimer() {
			this.subcommand('timer.start');
		},
		stopTimer() {
			this.subcommand('timer.stop');
		},
		pauseTimer() {
			this.subcommand('timer.pause');
		},
	},
};
</script>

<style scoped></style>
